// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';

import { isMobile } from '../../utils';

interface Props {
  onEndConversationClick: Function;
  isUserHost: boolean;
}

const CloseButton = ({ onEndConversationClick, isUserHost }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={isUserHost ? t('header.quitConversation') : t('header.exitConversation')}
      aria-label="quit-conversation"
      enterDelay={300}
      leaveDelay={200}
    >
      <Fab
        size="small"
        style={{
          width: 56,
          height: 56,
          backgroundColor: 'rgb(255, 0, 0, 1)',
          color: 'white',
        }}
        onClick={onEndConversationClick}
      >
        <CloseIcon />
      </Fab>
    </Tooltip>
  );
};

const mapStateToProps = ({ scribeConversation: { status }, scribeSession: { captioner } }) => ({
  isUserHost: status.host?.avaId === captioner.avaId,
});

export default connect(mapStateToProps)(CloseButton);
